import { isEmpty, pick } from 'lodash';

export const transformGetDiscounts = (data) => {
  const keys = ['id', 'key', 'name', 'value', 'uuid'];

  const args = {
    ...(data?.attributes || data),
    id: data?.id,
  };

  return pick(args, keys);
};

export const transformPutQuickCheckout = (payload) => {
  const { branch, cart, amount_tendered, change } = payload || {};

  const addOns = (row) => {
    const groups = [
      ...new Set(row?.selected_addons?.map((item) => item?.addon_group_uuid)),
    ];

    return {
      addons: groups?.reduce(
        (acc, item) => ({
          ...acc,
          [item]: row?.selected_addons
            ?.filter((subItem) => subItem?.addon_group_uuid === item)
            ?.map((subItem) => subItem?.uuid),
        }),
        {}
      ),
    };
  };

  const args = {
    branch_uuid: branch?.uuid,
    products: cart?.map((item) => ({
      ...(!isEmpty(item?.addons) && { addons: item?.addons }),
      ...(item?.selected_addons?.length > 0 && addOns(item)),
      uuid: item?.uuid,
      quantity: item?.quantity,
      ...(!isEmpty(item?.selected_variant) && {
        product_variant_uuid: item?.selected_variant?.product_variant_uuid,
      }),
      remarks: '',
      discounts:
        item?.discount_type || item?.discount_type?.length > 0
          ? item?.discount_type?.map((subItem) => subItem?.uuid)
          : [],
    })),
    amount_tendered,
    change,
  };

  return args;
};

export const transformGenerateDraft = (payload) => {
  const addOns = (row) => {
    const groups = [
      ...new Set(row?.selected_addons?.map((item) => item?.addon_group_uuid)),
    ];

    return {
      addons: groups?.reduce(
        (acc, item) => ({
          ...acc,
          [item]: row?.selected_addons
            ?.filter((subItem) => subItem?.addon_group_uuid === item)
            ?.map((subItem) => subItem?.uuid),
        }),
        {}
      ),
    };
  };

  const $payload = {
    products: payload?.map((item) => {
      if (item?.has_variant) {
        return {
          ...(item?.selected_addons?.length > 0 && addOns(item)),
          uuid: item?.uuid,
          product_variant_uuid: item?.selected_variant?.product_variant_uuid,
          quantity: item?.quantity,
        };
      }

      return {
        ...(item?.selected_addons?.length > 0 && addOns(item)),
        uuid: item?.uuid,
        quantity: item?.quantity,
      };
    }),
  };

  return $payload;
};

export const transformGetSettings = (item) => {
  const keys = [];

  const $item = {
    ...item?.attributes,
  };

  return pick($item, keys);
};
